export default "__VITE_ASSET__1qPUGm13__"